// auth/endpoints.js

let BASE_URL = "";
let LEGACY_BASE_URL = "";

const init = (config) => {
  BASE_URL = `${config.OAUTH.URL}/oauth2`;
  LEGACY_BASE_URL = `${config.BASE_URL}`;
};

export default {
  init,
  // OAuth
  token: () => `${BASE_URL}/token`,
  revoke: () => `${BASE_URL}/revoke`,
  // Legacy
  authenticate: () => `${LEGACY_BASE_URL}/authenticate.json`,
  passwordResetRequest: () => `${LEGACY_BASE_URL}/password/reset/request.json`,
  passwordReset: (userId, verificationToken) =>
    `${LEGACY_BASE_URL}/password/${userId}/${verificationToken}/reset.json`,
  passwordResetValidate: (userId, verificationToken) =>
    `${LEGACY_BASE_URL}/password/reset/validate/${userId}/${verificationToken}`,
};
